var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":_vm.PostalNames.PreloaderOverlay}},[_c('div',{staticClass:"preloader-wrapper",class:[_vm.customClasses, 'secondary']},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }